import React from "react";
import { UrlField } from "react-admin";
import { get } from "lodash";

const createLink = (record) =>
  `//${get(record, "domain_name")}.${get(
    record,
    "user.network.comparator_domain_name"
  )}`;
const DomainNameField = ({ record }) => (
  <UrlField source="url" record={{ url: createLink(record) }} />
);

export default DomainNameField;
